import React from 'react';
import StatCards from './StatCards';

const AdminTopBar = () => <StatCards />;

export default AdminTopBar;
